import { render, staticRenderFns } from "./gift-card-value.vue?vue&type=template&id=27183574&scoped=true&"
import script from "./gift-card-value.vue?vue&type=script&lang=js&"
export * from "./gift-card-value.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-value.vue?vue&type=style&index=0&id=27183574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27183574",
  null
  
)

export default component.exports